<template>

  <div>
    <!-- Add New Modal -->
    <modal-new-edit-ability
      v-model="blankData"
      id-modal="modal-add-new-ability"
      @refetchData="refetchData"
    />
    <!-- Filters -->
    <users-list-filters
      :role-filter.sync="roleFilter"
      :grupo-filter.sync="grupoFilter"
      :status-filter.sync="statusFilter"
      :role-options="roleOptions"
      :grupo-options="gruposOptions"
      :status-options="statusOptions"
      @statusFilter="updatedStatusFilter"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button
                v-if="$can('create', 'ACL')"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modal-add-new-ability
                variant="primary"
              >

                <span class="text-nowrap">
                  <feather-icon
                    class="cursor-pointer"
                    icon="PlusIcon"
                    size="16"
                  />
                  Abilidade
                </span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refListTableAbility"
        class="position-relative"
        :items="findAll"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Nenhum registro encontrado"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- Column: User -->
        <template #cell(nome_usuario)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.avatar"
                :text="avatarText(data.item.nome_usuario)"
                :variant="`light-${resolveUserRoleVariant(data.item.role)}`"
              />
            </template>
            <b-link
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.nome_usuario }}
            </b-link>
            <small class="text-muted">@{{ data.item.email_usuario }}</small>
          </b-media>
        </template>

        <!-- Column: data_inclusao -->
        <template #cell(data_inclusao)="data">
          <span>{{ data.item.data_inclusao | formatDateTimeBr }}</span>
        </template>

        <!-- Column: data_alteracao -->
        <template #cell(data_alteracao)="data">
          <span>{{ data.item.data_alteracao | formatDateTimeBr }}</span>
        </template>

        <!-- Column: Status -->
        <template #cell(ativo)="data">
          <b-badge
            pill
            :variant="`light-${resolveUserStatusVariant(data.item.ativo)}`"
            class="text-capitalize"
          >
            {{ data.item.ativo === 1 ? 'Ativo' : 'Inativo' }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div
            class="row justify-content-end align-content-center"
            style="gap: 5px; flex-wrap: nowrap"
          >
            <feather-icon
              v-if="$can('update', 'ACL')"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-tooltip.hover.top="'Editar'"
              v-b-modal.modal-add-new-ability
              style="color: var(--info);"
              size="20"
              class="icon-activity"
              icon="EditIcon"
              @click.stop="editarUsuario(data.item.id)"
            />

            <feather-icon
              v-if="$can('delete', 'ACL')"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-tooltip.hover.top="'Excluir'"
              v-b-modal.modal-confirme-delete-ability
              size="20"
              style="color: var(--danger);"
              icon="TrashIcon"
              class="icon-activity"
              @click="idAbilityDelete = data.item.id"
            />
          </div>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando {{ dataMeta.from }} para {{ dataMeta.to }} de {{
              dataMeta.of
            }} entradas</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>

    <ModalConfirm
      id-modal="modal-confirme-delete-ability"
      title-modal="Excluir Usuário"
      label-btn-ok="Deletar"
      variant-label-btn-ok="danger"
      variant-label-btn-cancel="secondary"
      message="Deseja realmente excluir o usuário?"
      @ok="deletedUser"
    />
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BPagination, VBModal, VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import {
  ref, onMounted,
} from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import ModalConfirm from '@/components/ModalConfirm.vue'
import Ripple from 'vue-ripple-directive'
import ModalNewEditAbility from '@/views/apps/abilidades/list/ModalNewEditAbility.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import UsersListFilters from './Filters.vue'
import useAbilityList from './useAbilityList'
import {formatDateTimeBr} from '@core/utils/filter'
export default {
  components: {
    ModalNewEditAbility,
    UsersListFilters,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BPagination,
    ModalConfirm,
    vSelect,
  },
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  filters: {
    formatDateTimeBr,
  },
  setup() {
    const idAbilityDelete = ref(null)
    const toast = useToast()
    const blankData = ref({
      id: null,
      action: '',
      subject: '',
      descricao: '',
    })

    const {
      findAll,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTableAbility,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      grupoFilter,
      statusFilter,
    } = useAbilityList()
    const gruposOptions = ref([])

    const updatedStatusFilter = () => {
      findAll()
    }

    const addUsuario = async () => {
      blankData.value = {
        id: null,
        action: '',
        subject: '',
        descricao: '',
      }
    }

    const deletedUser = async () => {
      if (idAbilityDelete.value === null) return
      await store.dispatch('abilityStore/delete', { id: idAbilityDelete.value })
        .then(resp => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Sucesso',
              text: resp.data.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          refetchData()
        })
      refetchData()
    }

    const editarUsuario = async idAbilityEdit => {
      await store.dispatch('abilityStore/findById', { id: idAbilityEdit })
        .then(data => {
          blankData.value = data.data
        })
    }

    const roleOptions = [
      { label: 'Admin', value: 'admin' },
      { label: 'Author', value: 'author' },
      { label: 'Editor', value: 'editor' },
      { label: 'Maintainer', value: 'maintainer' },
      { label: 'Subscriber', value: 'subscriber' },
    ]

    const grupoOptions = [
      { label: 'Basic', value: 'basic' },
      { label: 'Company', value: 'company' },
      { label: 'Enterprise', value: 'enterprise' },
      { label: 'Team', value: 'team' },
    ]

    const statusOptions = [
      { label: 'Todos', value: '' },
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ]

    onMounted(() => {

    })

    return {
      idAbilityDelete,
      addUsuario,
      blankData,
      editarUsuario,
      gruposOptions,
      findAll,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTableAbility,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      roleOptions,
      grupoOptions,
      statusOptions,

      // Extra Filters
      roleFilter,
      grupoFilter,
      statusFilter,
      updatedStatusFilter,
      deletedUser,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.icon-activity {
  cursor: pointer;
  margin-left: 0.5rem;
}

.icon-activity:hover {
  color: var(--white) !important;
  background-color: var(--primary) !important;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
